/**
 * KIR-5281: "N users · M endpoints" for a drill-down whose rows are one per
 * user per endpoint. Users and endpoints are counted distinctly, the same way
 * the parent row's Users and Endpoints columns count them, so the heading
 * always agrees with the row it was opened from.
 */
export function usersEndpointsLabel(
  rows: readonly { userId: string; machineId: string }[]
): string {
  const users = new Set(rows.map(r => r.userId)).size;
  const endpoints = new Set(rows.map(r => r.machineId)).size;
  return `${users} ${users === 1 ? 'user' : 'users'} · ${endpoints} ${endpoints === 1 ? 'endpoint' : 'endpoints'}`;
}
